import { render, staticRenderFns } from "./OrderButton.vue?vue&type=template&id=fe9b3ebe&scoped=true"
import script from "./OrderButton.vue?vue&type=script&lang=js"
export * from "./OrderButton.vue?vue&type=script&lang=js"
import style0 from "./OrderButton.vue?vue&type=style&index=0&id=fe9b3ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9b3ebe",
  null
  
)

export default component.exports